// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2SqLI","list":"PatternAutocomplete_list__1Yosq"};